import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authQueryKeys } from '../constants'

/**
 * Fetches user subscription info.
 * @param {Object} options - Additional options for the query.
 * @returns {Object} - Returns a list of subscriptions
 * {
  "organisationsTier": {},
  "hasSlot": true,
  "type": "FREE",
  "action": "NONE"
 }
 */

export const useGetSubscriptionsQuery = (options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api(`/api/v2/me/subscriptionInfo`, config)

    return data
  }

  return useQuery({
    queryKey: [authQueryKeys.SUBSCRIPTION_INFO],
    queryFn: handleQuery,
    ...options
  })
}
